import * as Yup from "yup";

export const initialValues = {
  code: null,
  name: null,
  nameEn: null,
  incomeType: null,
  rounding: null,
  frequencyOfPayment: null,
  overtimeCode: null
};

const IncomeSchema = Yup.object().shape({
  code: Yup.string().required("Please enter."),
  name: Yup.string().required("Please enter."),
  nameEn: Yup.string().required("Please enter."),
  incomeType: Yup.string().required("Please select."),
  rounding: Yup.string().required("Please select."),
  frequencyOfPayment: Yup.string().required("Please select."),
  overtimeCode: Yup.string().when('overTime', {
    is: true,
    then: (schema) => schema.required("Please select."),
    otherwise: (schema) => schema.nullable()
  })
});

export default IncomeSchema;
